'use es6';

import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import { openAuthWindow } from 'ads-account-connection/lib/Utils';
import Networks from 'ads-account-connection/lib/Networks';
const NETWORKS_TO_OAUTHOR = {
  [Networks.LINKEDIN]: 'linkedin',
  [Networks.ADWORDS]: 'google',
  [Networks.FACEBOOK]: 'facebook'
};
export default (network => {
  const portalId = PortalIdParser.get();
  return openAuthWindow(`${getFullUrl('app')}/oauthor/v1/${NETWORKS_TO_OAUTHOR[network]}/start/ads?portalId=${portalId}`);
});